import React, { ReactNode } from 'react'
import { Box, Button, styled } from '@mui/material'
import { Heading } from 'src/components/typography'
import { tokens } from 'src/styles/materialTheme'
import { useTranslation } from 'react-i18next'

type Props = {
  title: string
  handleSubmit: React.FormEventHandler<HTMLFormElement>
  children: ReactNode
  testId?: string
  isSubmitDisabled?: boolean
  hideSubmit?: boolean
}

const StyledSection = styled('section')(({ theme }) => ({
  backgroundColor: `${tokens.colors.white}`,
  paddingTop: '2.5rem',
  paddingBottom: '2.5rem',
  paddingLeft: '7.25rem',
  paddingRight: '7.25rem',
  [theme.breakpoints.only('mobile')]: {
    paddingLeft: '1.75rem',
    paddingRight: '1.75rem',
  },
  [theme.breakpoints.only('tablet')]: {
    paddingLeft: '2.75rem',
    paddingRight: '2.75rem',
  },
}))

const FormAdminSettingCard = ({
  title,
  handleSubmit,
  children,
  testId = 'AdminSettingsForm',
  isSubmitDisabled = false,
  hideSubmit = false,
}: Props) => {
  const { t } = useTranslation()

  return (
    <form onSubmit={handleSubmit}>
      <Box
        borderColor={tokens.colors.rsmGray.disabled}
        sx={{ flexWrap: 'wrap' }}>
        <StyledSection data-testid={`Sec_${testId}_FormBox`}>
          <Heading variant="h1" testId={`Hed_${testId}_Title`}>
            {title}
          </Heading>

          {/* Content area */}
          <Box sx={{ paddingTop: '1.5rem' }}>{children}</Box>

          {!hideSubmit && (
            <Box
              sx={{
                display: 'flex',
                flex: '1 1 0%',
                justifyContent: 'flex-start',
                paddingTop: '2rem',
              }}>
              <Button
                variant="contained"
                type="submit"
                data-testid={`Btn_${testId}_Submit`}
                disabled={isSubmitDisabled}>
                {t('AdminSettingsForm.SubmitButton')}
              </Button>
            </Box>
          )}
        </StyledSection>
      </Box>
    </form>
  )
}

export default FormAdminSettingCard
